import * as RSwitch from "@radix-ui/react-switch";
import { forwardRef, type ComponentPropsWithoutRef } from "react";
import { cn } from "@/lib/cn";

export const Switch = forwardRef<
  HTMLButtonElement,
  ComponentPropsWithoutRef<typeof RSwitch.Root>
>(({ className, ...props }, ref) => (
  <RSwitch.Root
    ref={ref}
    className={cn(
      "peer inline-flex h-5 w-9 shrink-0 cursor-pointer items-center rounded-full",
      "border border-stroke-strong bg-bg-raised",
      "transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-amber",
      "data-[state=checked]:bg-amber data-[state=checked]:border-amber",
      "disabled:cursor-not-allowed disabled:opacity-50",
      className,
    )}
    {...props}
  >
    <RSwitch.Thumb
      className={cn(
        "pointer-events-none block h-4 w-4 rounded-full bg-ink shadow",
        "ring-0 transition-transform",
        "translate-x-0.5 data-[state=checked]:translate-x-[18px]",
        "data-[state=checked]:bg-[#10141d]",
      )}
    />
  </RSwitch.Root>
));
Switch.displayName = "Switch";
